import { createReducer, on } from '@ngrx/store';
import { CustomTemplateActions } from './custom.actions';
import { Row } from './model/custom.model';

export interface CustomState {
  loading: boolean;
  error: string;
  rows: Row[];
}

export const initialState: CustomState = {
  loading: false,
  error: '',
  rows: [],
};

export const customReducer = createReducer(
  initialState,
  on(CustomTemplateActions.loadPage, state => ({
    ...state,
    loading: true,
  })),
  on(CustomTemplateActions.setRows, (state, { rows }) => ({
    ...state,
    rows,
  })),
  on(CustomTemplateActions.loadPageSuccess, state => ({
    ...state,
    loading: false,
  })),
  on(CustomTemplateActions.loadPageFailed, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
